// @ts-nocheck
import { AbstractServiceRequestOp } from "./AbstractServiceRequestOp";

export class ServiceRequestOp extends AbstractServiceRequestOp {
  constructor() {
    super();
  }
}
